<template>
  <InfoTooltip v-if="periods.length > 0" :text="tooltip" :showIcon="false">
    <span
      class="forwards-infeasibility-dot"
      role="img"
      :aria-label="tooltip"
    ></span>
  </InfoTooltip>
</template>

<script setup lang="ts">
import InfoTooltip from "@/components/common/InfoTooltip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

/**
 * The ochre dot beside a pool that cannot produce what it has sold.
 *
 * Renders nothing when there is nothing to warn about, so callers can place it unconditionally.
 * The reason is real text in a tooltip rather than a `title=` attribute: a `title` is invisible to
 * touch users and to anyone reading the row's contents aloud.
 */
const props = defineProps<{
  /** Period labels the pool is short in, e.g. `["2026-Q3", "2027"]`. */
  periods: string[];
}>();

const { t } = useI18n();

const tooltip = computed(() =>
  t("forwards.pools.infeasible_periods", { periods: props.periods.join(", ") })
);
</script>

<style scoped lang="scss">
.forwards-infeasibility-dot {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: var(--phoenix-warning);
  vertical-align: middle;
}
</style>
